import { SidebarSlider, SidebarSliderProps, responsiveVal } from '@graphcommerce/next-ui'
import { Container, Breakpoint, SxProps, Theme } from '@mui/material'

export function ProductSlider(
  props: Omit<SidebarSliderProps, 'sx'> & { containerMaxWidth?: Breakpoint; sx?: SxProps<Theme> },
) {
  const { containerMaxWidth = 'xl', sx = [] } = props

  return (
    <Container maxWidth={containerMaxWidth}>
      <SidebarSlider
        {...props}
        buttonSize='small'
        sx={[
          (theme) => ({
            '& .SidebarSlider-grid': {
              gridTemplateColumns: '100%',
            },
            '& .SidebarSlider-sidebar': {
              padding: '0',
              '& > :nth-of-type(2)': {
                display: 'none',
              },
            },
            '& .SidebarSlider-scroller': {
              gridAutoColumns: responsiveVal(180, 350),
              [theme.breakpoints.down('sm')]: {
                gridAutoColumns: `calc(50% - ${theme.spacings.md})`,
              },
            },
            '& .SidebarSlider-sliderButtons': {
              '& .MuiFab-root': {
                color: theme.palette.primary.contrastText,
                backgroundColor: theme.palette.primary.main,
              },
              color: theme.palette.primary.contrastText,
              display: { xs: 'flex', md: 'flex' },
            },
          }),
          ...(Array.isArray(sx) ? sx : [sx]),
        ]}
      />
    </Container>
  )
}
